import { mapState } from 'vuex';
import CONST from '@/utils/Constants'
import eventBus from '@/config/EventBus';
import ApiHelper from "@/helpers/ApiHelper";
import Notification from '@/utils/Notification'
import LayoutGreenScreen from "@/layouts/green-screen/layout-green-screen.vue"
import oButton from "@/objects/o-button/o-button.vue"
import oBlock from "@/objects/o-block/o-block.vue"
import oIconSms from "@/objects/o-icon/sms.vue"
import oKeyboard from "@/objects/o-keyboard/o-keyboard.vue"

export default {
  name: "vShareEmail",
  components: {
    "layout-green-screen": LayoutGreenScreen,
    "o-button": oButton,
    "o-block": oBlock,
    "o-icon-sms": oIconSms,
    "o-keyboard": oKeyboard
  },
  data() {
    return {
      input: ''
    }
  },
  methods: {
    stop() {
      eventBus.$emit(CONST.EVENT.INVENTION.STOPPED);
    },
    onChange (input) {
      this.input = input
    },
    onInputChange (input) {
      this.input = input.target.value
    },
    sendEmail() {
      let _this = this;

      let data = {
        'to': this.input,
        'text': this.$t('share_email.email.content') + process.env.VUE_APP_SOUVENIR_URL + this.$store.state.invention_id,
        'subject': this.$t('share_email.email.subject')
      }

      ApiHelper.post(CONST.API.ROUTE.EMAIL.SEND, data, {headersType: 'twilio', server: 'blockrocker'})
        .then(() => {
          Notification.add(this.$t('notifications.success.email-sent'), Notification.TYPE.SUCCESS, 5000);

          _this.$router.push({ name: 'share'});
        })
        .catch(() => {
          Notification.add(this.$t('notifications.error.email-not-sent'), Notification.TYPE.ERROR, 5000);
        });
    }
  },
  computed: {
    ...mapState(['locale']),
    content() {
      return this.$store.getters.content;
    },
    link() {
      return process.env.VUE_APP_SOUVENIR_URL + this.$store.state.invention_id;
    }
  }
}
